<div *ngIf="isLoading == false">
  <div class="row">
    <div class="col text-center" *ngIf="dupes.length > 0">
      <div class="alert alert-primary" role="alert">
        <small> {{ 'SIMILAR_RECORDS_DETECTED_ARE_THOSE_ONE_PERSON' | translate }}</small>
      </div>
    </div>
  </div>
  <div class="entity-list-item" *ngFor="let dupe of dupes; let index = index">
    <div class="row" *ngIf="dupe['resolved'] == false">
      <div
        class="text-center"
        [class.col-9]="dupe['answer'] == 1"
        [class.col]="dupe['answer'] == 0 || dupe['answer'] == 2"
      >
        <span>
          {{ dupe.member1.firstName }} {{ dupe.member1.lastName }} <br />
          {{
            _formatService.GetShortFormatedDate(
              dupe.member1.dateOfBirth,
              globalService.isRTL
            )
          }}</span
        >
      </div>
      <div [class.col-3]="dupe['answer'] == 1" *ngIf="dupe['answer'] == 1">
        <button
          class="btn btn-secondary btn-block"
          [class.btn-secondary]="
            dupe['answer'] == 1 &&
            (dupe['selection'] == 0 || dupe['selection'] == 2)
          "
          [class.btn-primary]="dupe['answer'] == 1 && dupe['selection'] == 1"
          (click)="dupe['selection'] = 1"
          type="button"
        >
          <span><i class="fas fa-check"></i></span>
        </button>
      </div>
    </div>
    <br>
    <div class="row" *ngIf="dupe['resolved'] == false">
      <div
        class="text-center"
        [class.col-9]="dupe['answer'] == 1"
        [class.col]="dupe['answer'] == 0 || dupe['answer'] == 2"
      >
        <span>
          {{ dupe.member2.firstName }} {{ dupe.member2.lastName }} <br />
          {{
            _formatService.GetShortFormatedDate(
              dupe.member2.dateOfBirth,
              globalService.isRTL
            )
          }}</span
        >
      </div>
      <div [class.col-3]="dupe['answer'] == 1" *ngIf="dupe['answer'] == 1">
        <button
          class="btn btn-block"
          [class.btn-secondary]="
            dupe['answer'] == 1 &&
            (dupe['selection'] == 0 || dupe['selection'] == 1)
          "
          [class.btn-primary]="dupe['answer'] == 1 && dupe['selection'] == 2"
          (click)="dupe['selection'] = 2"
          type="button"
        >
          <span><i class="fas fa-check"></i></span>
        </button>
      </div>
    </div>
    <div *ngIf="dupe['resolved'] == false">
      <br />
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 0 && dupe['resolved'] == false"
    >
      <div class="col-6">
        <button class="btn btn-primary btn-block" (click)="dupe['answer'] = 1">
          {{ 'YES' | translate }}</button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary btn-block" (click)="dupe['answer'] = 2">
          {{ 'NO' | translate }}</button>
      </div>
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 1 && dupe['resolved'] == false"
    >
      <div class="col-12">
        <div class="alert alert-secondary text-center" role="alert">
          <small>{{ 'CHOOSE_WHICH_RECORD_TO_KEEP_THEN_CLICK_MERGE' | translate }}</small>
        </div>
      </div>
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 1 && dupe['resolved'] == false"
    >
      <div class="col-6">
        <button
          class="btn btn-success btn-block"
          (click)="Merge(index, dupe['selection'])"
          [disabled]="dupe['selection'] == 0"
        >
          {{ 'MERGE' | translate }}</button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary btn-block"
          (click)="dupe['answer'] = 0; dupe['selection'] = 0"
        >
          {{ 'CANCEL_19766ED' | translate }}</button>
      </div>
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 2 && dupe['resolved'] == false"
    >
      <div class="col-12">
        <div class="alert alert-primary" role="alert">
          <small>{{ 'ARE_YOU_SURE_THOSE_ARE_TWO_DIFFERENT_PERSONS' | translate }}</small>
        </div>
      </div>
      <div class="col-6">
        <button
          class="btn btn-success btn-block"
          (click)="MarkAsDifferent(index)"
        >
          {{ 'YES' | translate }}</button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary btn-block"
          (click)="dupe['answer'] = 0; dupe['selection'] = 0"
        >
          {{ 'NO' | translate }}</button>
      </div>
    </div>
  </div>
</div>
